module.exports = __webpack_public_path__ + "static/media/07.9c410aed.jpg";